function initUserCountyInput() {
  const countryInput = $('#owner_home_address_attributes_country');

  updateUserInputsBasedOnCountry(countryInput.val());

  countryInput.on('change', function() {
    updateUserInputsBasedOnCountry($(this).val());
  });
}

function updateUserInputsBasedOnCountry(country) {
  const countryArray = ['MX', 'CA', 'US']

  const areaLabel = $('label[for="owner_home_address_attributes_area"]');
  const areaInput = $('#owner_home_address_attributes_area')

  if (countryArray.includes(country)) {
    const newAraText = areaLabel.text().replace(/( \*)?$/, ' *');
    areaLabel.text(newAraText);
    areaInput.prop('required', true)
  } else {
    const newAraText = areaLabel.text().replace('*', '');
    areaLabel.text(newAraText);
    areaInput.prop('required', false)
  }
}

$(document).ready(initUserCountyInput);
